<template>
  <div>
    <div class="currency_boxs"
         :style="{'background-color': data.bg}"
         v-for="x in 1"
         :key="x">
      <!-- <div class="curriculum_top">
        <div class="curriculum_title">
          商学院系列课
          <span style="margin-left:20px;font-size:14px">介绍内容</span>
          <span class="tabItem"
                v-for="h in 6"
                :key="h +'h'">{{h}}</span>
        </div>
      </div> -->
      <div class="curriculum_list"
           v-if="data && data.records && data.records.length!=0">
        <div class="curriculum_item"
             :style="{'width':'calc((100% - 120px) /'+ 4 +')'}"
             @click="toDetails(item)"
             @mouseenter="mouseover(index)"
             @mouseleave="mouseout"
             v-for="(item,index) in data.records"
             :key="index">
          <!-- <div class="cove"
               v-if="activeIndex == index"
               @click="toDetails(item)">
            <transition name="el-zoom-in-top">
              <el-button type="danger"
                         class="mainBgColor">查看详情</el-button>
            </transition>
          </div> -->
          <el-image style="width:100%; height: 168px;border-radius: 10px 10px 0 0;"
                    :src="item.coverPicture"></el-image>
          <div class="curriculum_item_box">
            <div class="curriculum_item_title">{{item.name.length>26?item.name.slice(0,25)+'...':item.name}}</div>
            <div class="curriculum_item_center">
              <div class="l">章节:{{item.chapterCount}}节</div>
              <div class="l"
                   v-if="item.studyCount && item.studyCount>0">学习人数:{{item.studyCount}}</div>
              <div class="l"
                   v-if="item.totalSpan && item.totalSpan>0">时长：{{convertTime(item.totalSpan)}}</div>
            </div>
            <!-- <div class="lecturer">讲师：王波 | 生鲜实战专家</div> -->
          </div>
        </div>
      </div>
      <el-empty v-else
                style="width: 100%;"
                description="暂无课程"></el-empty>
      <div v-if="data.status == 'more' && data.records && data.records.length!=0"
           class="flexCenter"
           style="color:#DE1F26;font-size:16px;margin-bottom: 20px;width: 100%;cursor: pointer;">
        <span @click="toList">更多课程内容<i class="el-icon-arrow-right"></i><i class="el-icon-arrow-right"></i></span>
      </div>
      <div v-if="data.status == 'paging' && data.records && data.records.length!=0"
           class="flexCenter"
           style="margin-bottom: 20px;">
        <el-pagination background
                       @current-change="currentChange"
                       layout="prev, pager, next"
                       :page-size="data.size"
                       :total="data.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: {
        return: { list: [], total: 0 }
      }
    },
    status: {
      type: String,
      default: {
        return: 'more'
      }
    }
  },
  data () {
    return {
      activeIndex: -1,
      url: 'https://img0.baidu.com/it/u=410476708,2625048454&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800'
    }
  },
  methods: {
    mouseover (e) {
      console.log(e)
      this.activeIndex = e
    },
    mouseout () {
      this.activeIndex = -1
    },
    convertTime (span) {
      if (span == null) {
        return '0秒'
      }
      let result = parseInt(span);
      // let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
      // let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
      // let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));

      let h = Math.floor(result / 3600);
      let m = Math.floor((result / 60 % 60));
      let s = Math.floor((result % 60));
      let res = '';
      if (h != '0') res += `${h}小时`;
      if (m != '0') res += `${m}分`;
      res += `${s}秒`;
      return res;
    },
    currentChange (e) {
      console.log(e)
      this.$emit('currrntChange', e)
    },
    toList () {
      this.$router.push('/Screen')
    },
    toDetails (item) {
      this.$router.push('/Curriculum?courseId=' + item.id)
    }
  }
}
</script>
<style lang="less" scoped>
.currency_boxs {
  width: 1200px;
  background-color: #f5f5f5;
  margin-top: 20px;
  .curriculum_top {
    display: flex;
    .curriculum_title {
      flex: 1;
      .tabItem {
        display: inline-block;
        margin: 0 20px;
      }
    }
  }
  .curriculum_list {
    width: 1200px;
    display: flex;
    flex-wrap: wrap;
    margin: 20px 0;
    .curriculum_item {
      // width: calc((100% - 120px) / 4);
      border-radius: 10px;
      margin-right: 40px;
      margin-bottom: 30px;
      background-color: #fff;
      position: relative;
      cursor: pointer;
      .cove {
        position: absolute;
        z-index: 10;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 10px;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .curriculum_item_box {
        padding: 20px 10px;
        box-sizing: border-box;
        .lecturer {
          color: #666666;
          font-size: 12px;
        }
        .curriculum_item_center {
          display: flex;
          margin: 15px 0 0 0;
          flex-wrap: wrap;
          .l {
            background-color: #f2f4f7;
            color: '#333333';
            font-size: 12px;
            padding: 6px 8px;
            box-sizing: border-box;
            border-radius: 12px;
            margin-right: 10px;
            margin-bottom: 10px;
          }
        }
        .curriculum_item_title {
          overflow: hidden;
          display: -webkit-box;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          white-space: normal;
          font-size: 18px;
          font-weight: 600;
          color: #333;
        }
      }
    }
    .curriculum_item:nth-child(4) {
      margin-right: 0;
    }
    .curriculum_item:nth-child(8) {
      margin-right: 0;
    }
    .curriculum_item:nth-child(12) {
      margin-right: 0;
    }
  }
}
</style>